<template>
  <job-template>
    <template slot="top-section">
      <banner title="Profile Created Successfully" :active.sync="showBanner" />
      <search-bar />
    </template>
    <template slot="content-area">
      <margin-title :subtitle="this.$t('nav.jobs')" />
      <jobs-list :jobs="jobs" />
    </template>
  </job-template>
</template>
<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'
import Banner from '@/components/general/banner'
import JobsList from '../components/jobs/jobs-list.vue'
import MarginTitle from '@/components/margin-title'
import SearchBar from '../components/jobs/search'
import JobTemplate from '@/templates/job-template'

export default {
  components: {
    JobsList,
    Banner,
    MarginTitle,
    SearchBar,
    JobTemplate
  },
  computed: {
    ...mapState('jobs', [
      'jobs'
    ]),
    ...mapState('notifications', [
      'showProfileBanner'
    ]),
    keyword () {
      const q = this.$route.meta.stacks ? 'stacks' : null
      return this.$route.query.q || q
    }
  },
  watch: {
    $route () {
      // this.search({keyword: this.keyword})
    }
  },
  methods: {
    ...mapActions('jobs', [
      'getJobs',
      'search'
    ]),
    ...mapGetters('jobs', ['getFilters']),
    ...mapMutations('jobs', [
      'resetJobs', 'resetFilters'
    ]),
    ...mapMutations('notifications', [
      'setShowProfileBanner'
    ])
  },
  async mounted () {
    await this.search({...this.getFilters()})
    if (this.showProfileBanner) {
      this.setShowProfileBanner(false)
      this.showBanner = true
    }
  },
  destroyed () {
    this.resetFilters()
  },
  data () {
    return {
      showBanner: false
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .margin {
  margin-top: 1.5rem !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/jobs-list.vue